import { ENDPOINT } from '~/constants';

import { vestigasAiApi } from '~/services/kyClient';

import { log } from '~/utils';

import {
  type ValidateLabelingPayload,
  type ValidateLabelingResponse,
} from './types';
import { zodValidateLabelingSchema } from './validations';

/**
 * Validates labeling by counting unique field appearances per file and identifying missing fields.
 * @returns The validation result.
 * @see https://ai.vestigas.com/redoc#operation/labeling_validation_labeling_validation_get
 */
export const validateLabeling = async (
  queryParameters: ValidateLabelingPayload,
) => {
  try {
    const response = await vestigasAiApi
      .get(ENDPOINT.AI.VALIDATE_LABELING(), {
        searchParams: queryParameters,
        validate: {
          searchParams: zodValidateLabelingSchema,
        },
      })
      .json<ValidateLabelingResponse>();

    return response;
  } catch (error) {
    log.error({
      message: 'Error validating labeling',
      error,
    });

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
